import React from "react";

const TagList = ({ tags = [], loading = false }) => {
  if (loading) {
    return (
      <div className="placeholder-glow">
        {[...Array(6)].map((_, i) => (
          <span key={i} className="badge bg-light border text-light placeholder col-2 me-2 mb-2">
            &nbsp;
          </span>
        ))}
      </div>
    );
  }

  if (!Array.isArray(tags) || !tags.length) {
    return <p className="text-muted mb-0">Aucun tag.</p>;
  }

  return (
    <div className="d-flex flex-wrap gap-2">
      {tags.map((t) => (
        <a
          key={t.id || t.slug}
          href={`/tag/${t.slug ?? t.id}`}
          className="badge bg-light text-dark border"
        >
          #{t.name}
        </a>
      ))}
    </div>
  );
};

export default TagList;
